export default __webpack_public_path__ + "static/media/bl17.d878140f.png";